/**
 * internal dependencies
 */
import { getParameters } from '../../../helpers/helpers';

import { PIN_POOL_FORM, VEHICLE_POOL_FORM } from './pin-pool/utils/pin-pool-types';
import { createNewCardGroup } from './newCardGroup/create-new-cardgroup';
import { getIndividualCardGroup } from './existingCardGroup/get-cardgroup-info';
import { updateCardGroup } from './existingCardGroup/update-cardgroup';
import HandleDriverPinPool from './pin-pool/handle-driver-pin-pool';
import HandleVehiclePinPool from './pin-pool/handle-vehicle-pin-pool';

/**
 * Handles routing for the Card Group form based on the groupAction parameter
 * 
 * @returns void
 */
export const formCardGroups = () => {
  const formAction = getParameters('groupAction');

  switch(formAction) {
    case 'add':
      createNewCardGroup();
      break;
    case 'edit':
    case 'view':
      getIndividualCardGroup();
      updateCardGroup();
      break;
  } 

  if ( PIN_POOL_FORM.ppForm ) {
    HandleDriverPinPool();
  }

  if ( VEHICLE_POOL_FORM.vpForm ) {
    HandleVehiclePinPool();
  }
}